import { Field, RuleType } from "react-querybuilder";
import isEqual from "lodash/isEqual";
import { IFilterRule } from "./types";

/**
 * Returns the default value for new rules.
 */
export const getDefaultValue = (defaultRule: RuleType): string | string[] => {
    return typeof defaultRule.value === "object" ? [] : defaultRule.value;
};

/**
 * Returns the default field for new rules.
 */
export const getDefaultField = (rules: RuleType[], fields: Field[]): string => {
    const usedRuleValues = rules.map((rule) => rule.field);
    // We are using `name` as identifier for each field
    const defaultField = fields.filter((field) => !usedRuleValues.includes(field.name) || !field.isUnique)?.[0]?.name;
    return defaultField;
};

export const didTheFiltersChange = (initialFilters: IFilterRule[], newFilters: IFilterRule[]): boolean => {
    if (initialFilters.length !== newFilters.length) {
        return true;
    }
    const newValues = [];
    initialFilters.forEach((initialFilter) => {
        newFilters.forEach((newFilter) => {
            if (initialFilter.field === newFilter.field && isEqual(initialFilter.value, newFilter.value)) {
                newValues.push(newFilter.value);
            }
        });
    });
    return newValues.length !== initialFilters.length;
};

export const doesAllFiltersHaveValues = (newFilters: IFilterRule[]): boolean => {
    const hasIncompleteValue = newFilters.some((newFilter) => {
        if (Array.isArray(newFilter.value)) {
            return newFilter.value?.length === 0;
        }
        if (typeof newFilter.value === "string") {
            return newFilter.value === "";
        } else if (newFilter.value?.children) {
            return newFilter.value.children?.length === 0;
        }
    });
    return !hasIncompleteValue;
};
